import { render, staticRenderFns } from "./SLStatements2.vue?vue&type=template&id=13b81422&"
import script from "./SLStatements2.vue?vue&type=script&lang=js&"
export * from "./SLStatements2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports